import { useState } from 'react';
import { Artist } from 'types';
import api from 'utils/api';

interface UpdateArtistProfilePayload {
  location?: string;
  genres?: string[];
  skills?: string[];
  workPreference?: string;
  isOnboarded?: boolean;
}

interface UseUpdateArtistProfileResult {
  updateProfile: (
    artistId: number,
    payload: UpdateArtistProfilePayload
  ) => Promise<{ success: boolean; data?: Artist; error?: string }>;
  isLoading: boolean;
  error: string | null;
}

export function useUpdateArtistProfile(): UseUpdateArtistProfileResult {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const updateProfile = async (
    artistId: number,
    payload: UpdateArtistProfilePayload
  ): Promise<{ success: boolean; data?: Artist; error?: string }> => {
    setIsLoading(true);
    setError(null);

    try {
      const result: Artist = await api.collabClub.updateMyProfile({
        id: artistId,
        data: payload,
      });

      setIsLoading(false);
      return { success: true, data: result };
    } catch (err: any) {
      console.error('Failed to update artist profile:', err);
      const errorMessage = err?.data?.message || err.message || 'Failed to update profile';
      setError(errorMessage);
      setIsLoading(false);
      return {
        success: false,
        error: errorMessage,
      };
    }
  };

  return {
    updateProfile,
    isLoading,
    error,
  };
}
